// Select.tsx
import React, { useEffect, useRef, useState } from "react";
import { IconSizeEnum } from "../../../types/AppTypes";
import { IconManager } from "../IconManager/IconManager";
import { ReactComponent as ChevronDownIcon } from "../../../icons/chevronDown.svg";
import {
  SelectContainer,
  RangeContainer,
  StyledInputContainer,
} from "./SelectRange.style";
import Input, { InputSizes } from "../Input/Input";
import MultiRangeSlider from "../MultiRangeSlider/MultiRangeSlider";
import { Button, ButtonSizes, ButtonVariants } from "../Button/Button";
import { CONFIRM_LABEL } from "../../../constants/Dictionary";
import { Divider } from "../Divider/Divider";

interface SelectProps {
  value?: {
    min: number;
    max: number;
  };
  onChange: (value: { min: number; max: number }) => void;
  label?: string;
}

export const SelectRange = ({ label, value, onChange }: SelectProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [tmpSelectedRange, setTmpSelectedRange] = useState<{
    min: number;
    max: number;
  }>({ min: 0, max: 100 });

  const toggleOpen = () => setIsOpen(!isOpen);

  const useOutsideAlerter = (ref: React.RefObject<HTMLDivElement>) => {
    useEffect(() => {
      function handleClickOutside(event: MouseEvent) {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          setIsOpen(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };
  const wrapperRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(wrapperRef);

  const getDefaultValueInput = () => {
    return value ? `${value.min} - ${value.max}%` : undefined;
  };

  const confirmRange = () => {
    onChange(tmpSelectedRange);
    setIsOpen(false);
  };

  return (
    <SelectContainer ref={wrapperRef}>
      <StyledInputContainer>
        <Input
          label={label}
          onClick={toggleOpen}
          endIcon={
            <IconManager size={IconSizeEnum.SMALL} onClick={toggleOpen}>
              <ChevronDownIcon />
            </IconManager>
          }
          readOnly
          inputSize={InputSizes.REGULAR}
          allowClear={false}
          value={getDefaultValueInput()}
        />
      </StyledInputContainer>
      {isOpen && (
        <RangeContainer>
          <MultiRangeSlider onChange={setTmpSelectedRange} value={value} />
          <Divider />
          <div className="confirm-container">
            <Button
              variant={ButtonVariants.PRIMARY}
              size={ButtonSizes.SMALL}
              label={CONFIRM_LABEL}
              onClick={confirmRange}
            />
          </div>
        </RangeContainer>
      )}
    </SelectContainer>
  );
};
